const getInitialState = () => ({
	campaigns: [],
	sequences: [],
	sequencesJoinedMessage: '',
	generalErrors: []
});

export default getInitialState;
